exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#pdf_container {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index: 1000000;\n    top: 0;\n    left: 0;\n    background: rgba(0,0,0,0.5);\n    overflow: scroll;\n}\n#viewerContainer {\n    width: 80%;\n    height: 100%;\n    margin: 0 auto;\n}\n#viewerContainer object {\n    width: 100%;\n    height: 100%;\n}\n#closePDF {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: unset;\n    border: 0;\n    cursor: pointer;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87d96000","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/player/PDFViewer.vue
// module id = F+Bn
// module chunks = 2 3 4 5 6